import React from "react";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";

import "./Sms.scss";

const whenNumberChanges = (
	<a className="sms-terms-link" href="https://help.okcupid.com/article/202-sms-verification" target="_blank" rel="noopener noreferrer">
		<Str>Learn what happens when your number changes.</Str>
	</a>
);

const Terms = () => (
	<Strf
		className="sms-terms"
		vars={{ whenNumberChanges }}
	>
		We will send a text with a verification code.
		Message and data rates may apply. $whenNumberChanges
	</Strf>
);

export default Terms;



// WEBPACK FOOTER //
// ./src/shared/components/Sms/Terms.jsx